var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-index" },
    [
      _c("div", { staticClass: "con-header" }, [_vm._v("我的合同")]),
      _c(
        "div",
        { staticClass: "con-list-wrap" },
        [
          _c(
            "el-tabs",
            _vm._l(_vm.conDataList, function(conData) {
              return _c(
                "el-tab-pane",
                {
                  key: conData.templateModeCode,
                  attrs: { label: conData.templateMode }
                },
                [
                  _c(
                    "ul",
                    { staticClass: "ul-cls con-list clearfix" },
                    [
                      _vm._l(conData.items, function(con) {
                        return _c("div", { key: con.id }, [
                          con.isDefault == "1"
                            ? _c("li", [
                                _c(
                                  "div",
                                  { staticClass: "flex justify_between" },
                                  [
                                    _c("p", { staticClass: "f16 fb" }, [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("[默认]")
                                      ]),
                                      _vm._v(_vm._s(con.name))
                                    ])
                                  ]
                                ),
                                _c("div", { staticClass: "box10" }),
                                con.nameMap.categoryOptionsList &&
                                con.nameMap.categoryOptionsList.split(",")
                                  .length > 1
                                  ? _c("p", [
                                      _c("span", { staticClass: "fb" }, [
                                        _vm._v("应用商品：")
                                      ]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            con.nameMap.categoryOptionsList.split(
                                              ","
                                            )[0]
                                          ) +
                                          _vm._s(
                                            "、" +
                                              con.nameMap.categoryOptionsList.split(
                                                ","
                                              )[1] +
                                              "..."
                                          ) +
                                          " 等品类下所有商品\n              "
                                      )
                                    ])
                                  : con.nameMap.categoryOptionsList &&
                                    con.nameMap.categoryOptionsList.split(",")
                                      .length > 0
                                  ? _c("p", [
                                      _c("span", { staticClass: "fb" }, [
                                        _vm._v("应用商品：")
                                      ]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            con.nameMap.categoryOptionsList.split(
                                              ","
                                            )[0] + "..."
                                          ) +
                                          " 等品类下所有商品\n              "
                                      )
                                    ])
                                  : _c("p", [
                                      _c("span", { staticClass: "fb" }, [
                                        _vm._v("应用商品：")
                                      ]),
                                      _vm._v(" 暂无")
                                    ]),
                                _c("p", [
                                  _c("span", { staticClass: "fb" }, [
                                    _vm._v("应用客户：")
                                  ]),
                                  _vm._v(" 所有无专属合同模板客户")
                                ]),
                                _c(
                                  "p",
                                  [
                                    _c("span", { staticClass: "fb" }, [
                                      _vm._v("自动签署：")
                                    ]),
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.editAutoSign(con)
                                        }
                                      },
                                      model: {
                                        value: con.isAutoSign,
                                        callback: function($$v) {
                                          _vm.$set(con, "isAutoSign", $$v)
                                        },
                                        expression: "con.isAutoSign"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "box10" }),
                                _c("p", [
                                  _vm._v(
                                    "无专属合同模板的客户，下单购买以上品类商品时，签署此合同"
                                  )
                                ]),
                                _c("div", { staticClass: "box10" }),
                                _c(
                                  "div",
                                  { staticClass: "t_right" },
                                  [
                                    conData.editVisiable
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.updateContrat(con)
                                              }
                                            }
                                          },
                                          [_vm._v("合同修改")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ])
                            : _vm._e(),
                          con.isDefault == "0"
                            ? _c("li", [
                                _c(
                                  "div",
                                  { staticClass: "flex justify_between" },
                                  [
                                    _c("p", { staticClass: "f16 fb" }, [
                                      _c("span", { staticClass: "red" }, [
                                        _vm._v("[专属]")
                                      ]),
                                      _vm._v(_vm._s(con.name))
                                    ]),
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.edit(con)
                                        }
                                      },
                                      model: {
                                        value: con.isEnable,
                                        callback: function($$v) {
                                          _vm.$set(con, "isEnable", $$v)
                                        },
                                        expression: "con.isEnable"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "box10" }),
                                _c("div", { staticClass: "box110" }, [
                                  con.nameMap.goodsNameList &&
                                  con.nameMap.goodsNameList.split(",").length >
                                    1
                                    ? _c("p", [
                                        _c("span", { staticClass: "fb" }, [
                                          _vm._v("应用商品：")
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              con.nameMap.goodsNameList.split(
                                                ","
                                              )[0]
                                            ) +
                                            _vm._s(
                                              "、" +
                                                con.nameMap.goodsNameList
                                                  .split(",")[1]
                                                  .substring(0, 4) +
                                                "..."
                                            ) +
                                            "等\n                  " +
                                            _vm._s(
                                              con.nameMap.goodsNameList.split(
                                                ","
                                              ).length
                                            ) +
                                            "个商品\n                "
                                        )
                                      ])
                                    : con.nameMap.goodsNameList &&
                                      con.nameMap.goodsNameList.split(",")
                                        .length > 0
                                    ? _c("p", [
                                        _c("span", { staticClass: "fb" }, [
                                          _vm._v("应用商品：")
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              con.nameMap.goodsNameList.split(
                                                ","
                                              )[0] + "..."
                                            ) +
                                            "等 " +
                                            _vm._s(
                                              con.nameMap.goodsNameList.split(
                                                ","
                                              ).length
                                            ) +
                                            "个商品\n                "
                                        )
                                      ])
                                    : _c("p", [
                                        _c("span", { staticClass: "fb" }, [
                                          _vm._v("应用商品：")
                                        ]),
                                        _vm._v(" 暂无")
                                      ]),
                                  con.nameMap.customerNameList &&
                                  con.nameMap.customerNameList.split(",")
                                    .length > 1
                                    ? _c("p", [
                                        _c("span", { staticClass: "fb" }, [
                                          _vm._v("应用客户：")
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              con.nameMap.customerNameList.split(
                                                ","
                                              )[0]
                                            ) +
                                            _vm._s(
                                              "、" +
                                                con.nameMap.customerNameList
                                                  .split(",")[1]
                                                  .substring(0, 16) +
                                                "..."
                                            ) +
                                            "等\n                  " +
                                            _vm._s(
                                              con.nameMap.customerNameList.split(
                                                ","
                                              ).length
                                            ) +
                                            "个客户\n                "
                                        )
                                      ])
                                    : con.nameMap.customerNameList &&
                                      con.nameMap.customerNameList.split(",")
                                        .length > 0
                                    ? _c("p", [
                                        _c("span", { staticClass: "fb" }, [
                                          _vm._v("应用客户：")
                                        ]),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              con.nameMap.customerNameList.split(
                                                ","
                                              )[0] + "..."
                                            ) +
                                            "等 " +
                                            _vm._s(
                                              con.nameMap.customerNameList.split(
                                                ","
                                              ).length
                                            ) +
                                            "个客户\n                "
                                        )
                                      ])
                                    : _c("p", [
                                        _c("span", { staticClass: "fb" }, [
                                          _vm._v("应用客户：")
                                        ]),
                                        _vm._v(" 暂无")
                                      ]),
                                  _c(
                                    "p",
                                    [
                                      _c("span", { staticClass: "fb" }, [
                                        _vm._v("自动签署：")
                                      ]),
                                      _c("el-switch", {
                                        attrs: {
                                          "active-value": 1,
                                          "inactive-value": 0
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.editAutoSign(con)
                                          }
                                        },
                                        model: {
                                          value: con.isAutoSign,
                                          callback: function($$v) {
                                            _vm.$set(con, "isAutoSign", $$v)
                                          },
                                          expression: "con.isAutoSign"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "box10" }),
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(con.lastUpdateTimeStr) +
                                        " " +
                                        _vm._s(con.updataName) +
                                        " 操作。"
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "box30" }),
                                con.isDefault == "0"
                                  ? _c(
                                      "div",
                                      { staticClass: "t_right" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.openGoodsPop(con)
                                              }
                                            }
                                          },
                                          [_vm._v("应用商品")]
                                        ),
                                        con.templateMode != "VIP_CONTRACT"
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "primary",
                                                  size: "small"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openCustomerPop(
                                                      con
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("应用客户")]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.updateContrat(con)
                                              }
                                            }
                                          },
                                          [_vm._v("合同修改")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.delContrat(con)
                                              }
                                            }
                                          },
                                          [_vm._v("删除")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      }),
                      conData.editVisiable
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "contract_add flex align_center justify_center",
                              on: {
                                click: function($event) {
                                  return _vm.addContrat(
                                    conData.templateModeCode
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ]
              )
            }),
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "con-box50" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择客户",
            visible: _vm.customerPop.chooseClientVisible,
            "close-on-click-modal": false,
            width: "800px",
            "show-close": false,
            "custom-class": "chooseClientPop"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.customerPop, "chooseClientVisible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入客户名称" },
                    model: {
                      value: _vm.customerPop.searchCustomer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.customerPop.searchCustomer, "name", $$v)
                      },
                      expression: "customerPop.searchCustomer.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "float-left client_pop_query",
                  on: {
                    click: function($event) {
                      return _vm.listCustomer(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ]),
            _c("div", { staticClass: "box30" }),
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("客户分组")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择客户分组", clearable: "" },
                      model: {
                        value: _vm.customerPop.searchCustomer.groupId,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.customerPop.searchCustomer,
                            "groupId",
                            $$v
                          )
                        },
                        expression: "customerPop.searchCustomer.groupId"
                      }
                    },
                    _vm._l(_vm.customerPop.groupDataList, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ]),
            _c("div", { staticClass: "box20" }),
            _c("div", { staticClass: "clear ps_group_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("我的客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.customerPop.customerDataList, function(
                      item,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.customerDialogSelect(item)
                            }
                          }
                        },
                        [
                          item.isCheck
                            ? _c("div", {
                                staticClass: "client_list_mask",
                                domProps: {
                                  innerHTML: _vm._s(
                                    "归属合同模板：" + item.attrName
                                  )
                                }
                              })
                            : _vm._e(),
                          _c(
                            "p",
                            { staticClass: "group_item_name ellipsis_two" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c("p", [
                            _vm._v(
                              "身份：" +
                                _vm._s(item.targetType === 1 ? "个人" : "企业")
                            )
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选客户")]),
                _c("div", { staticClass: "client_list_pop_main" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.conCustomerSel.customerSelList, function(
                      item,
                      index
                    ) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectCustomer(item)
                            }
                          }
                        }),
                        _c(
                          "p",
                          { staticClass: "group_item_name ellipsis_two" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("p", [
                          _vm._v(
                            "身份：" +
                              _vm._s(item.targetType === 1 ? "个人" : "企业")
                          )
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box20" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.customerPop.currentPageCustomer,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.customerPop.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.customerPop.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChangeCustomer,
              "current-change": _vm.handleCurrentChangeCustomer
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.customerDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.customerDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.goodsPop.chooseGoodVisible,
            "close-on-click-modal": false,
            width: "1140px",
            top: "80px",
            "show-close": false,
            "custom-class": "chooseGoodPop"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.goodsPop, "chooseGoodVisible", $event)
            }
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "clear ps_search_wrap" }, [
              _c(
                "span",
                { staticClass: "float-left pad15_r lin_30 inlineblock" },
                [_vm._v("货品名称")]
              ),
              _c(
                "div",
                { staticClass: "ps_search float-left" },
                [
                  _c("el-input", {
                    attrs: { type: "text", placeholder: "请输入货品名称" },
                    model: {
                      value: _vm.goodsPop.searchGoods.name,
                      callback: function($$v) {
                        _vm.$set(_vm.goodsPop.searchGoods, "name", $$v)
                      },
                      expression: "goodsPop.searchGoods.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "float-left client_pop_query",
                  on: {
                    click: function($event) {
                      return _vm.listShopGoods(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ]),
            _c("div", { staticClass: "clear appoint_goods_list" }, [
              _c("div", { staticClass: "float-left client_list_all" }, [
                _c("p", [_vm._v("本店货品")]),
                _c("div", { staticClass: "client_list_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.goodsPop.goodsDataList, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              return _vm.goodsDialogSelect(item)
                            }
                          }
                        },
                        [
                          item.isCheck
                            ? _c("div", {
                                staticClass: "client_list_mask",
                                domProps: {
                                  innerHTML: _vm._s(
                                    "归属合同模板：" + item.attrName
                                  )
                                }
                              })
                            : _vm._e(),
                          _c("img", {
                            staticClass: "float-left appoint_good_img",
                            attrs: { src: item.picUrl, alt: "" }
                          }),
                          _c(
                            "div",
                            { staticClass: "float-left appoint_good_main" },
                            [
                              _c("p", { staticClass: "ellipsis f14" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _c("p", { staticClass: "f12" }, [
                                _vm._v("规格：" + _vm._s(item.spec))
                              ]),
                              _c("p", { staticClass: "f12" }, [
                                _vm._v("原价：¥" + _vm._s(item.marketPriceStr))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "float-right client_list_me" }, [
                _c("p", [_vm._v("已选货品")]),
                _c("div", { staticClass: "client_list_wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.goodsSel.goodsSelList, function(item, index) {
                      return _c("li", { key: index }, [
                        _c("i", {
                          staticClass: "iconfont icon-shibai fb",
                          on: {
                            click: function($event) {
                              return _vm.removeSelectGoods(item)
                            }
                          }
                        }),
                        _c("img", {
                          staticClass: "float-left appoint_good_img",
                          attrs: { src: item.picUrl, alt: "" }
                        }),
                        _c(
                          "div",
                          { staticClass: "float-left appoint_good_main" },
                          [
                            _c("p", { staticClass: "ellipsis f14" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _c("p", { staticClass: "f12" }, [
                              _vm._v("规格：" + _vm._s(item.spec))
                            ]),
                            _c("p", { staticClass: "f12" }, [
                              _vm._v("原价：¥" + _vm._s(item.marketPriceStr))
                            ])
                          ]
                        )
                      ])
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "box10" }),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.goodsPop.currentGoodsPage,
              "page-sizes": [10, 20, 30],
              "page-size": _vm.goodsPop.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.goodsPop.totalCount
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsDialogConfirm }
                },
                [_vm._v("确 认")]
              ),
              _c("el-button", { on: { click: _vm.goodsDialogClose } }, [
                _vm._v("取 消")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }